import { useCallback, useState } from "react";
import { toast } from "react-toastify";
import { getCurrentProjectID } from "../../../../../app_shared_functions";
import {
  buildBaseNetworkPayload,
  buildRouterPayload,
  buildSubnetPayload,
} from "./helpers";
import { createCompleteNetwork, createNetwork } from "../../actions";
import { useDispatch, useSelector } from "react-redux";
import { getProjectsObject } from "../../../../../selectors/projects";
import useZoneId from "../../../../../custom-hooks/region/useZoneId";
import { TypedThunkDispatch } from "../../../../../reducers/thunk/type";
import { closeSlidingMenuLayer } from "../../../../../actions/toggleSlidingMenu";
import { useNetworkFormContext } from "../context/NetworkFormContext";

const useNetworkCreationHandler = (createAnother: boolean) => {
  const { formData, predefined_params } = useNetworkFormContext();

  const [isCreating, setIsCreating] = useState(false);

  const projects = useSelector(getProjectsObject);
  const zoneId = useZoneId(formData?.region || predefined_params?.region);
  const dispatch: TypedThunkDispatch = useDispatch();

  const handleNetworkCreation = useCallback(
    (actionPromise: Promise<any>) => {
      setIsCreating(true);
      actionPromise
        .then(() => {
          toast.success("Creating network started...");
          if (!createAnother) {
            dispatch(closeSlidingMenuLayer());
          }
        })
        .catch((err) => {})
        .finally(() => {
          setIsCreating(false);
        });
    },
    [dispatch, createAnother],
  );

  const prepareNetworkCreation = useCallback(() => {
    const region = formData.region || predefined_params?.region;
    console.log(region);

    const projectId = getCurrentProjectID(projects, region) || "";

    const networkPayload = {
      network: buildBaseNetworkPayload(formData, zoneId),
    };

    if (formData.completeCreate) {
      networkPayload.network.subnets = buildSubnetPayload(formData, zoneId);
      networkPayload.network.router = buildRouterPayload(formData);

      const promise = dispatch(
        createCompleteNetwork(region, projectId, networkPayload),
      );
      handleNetworkCreation(promise);
    } else {
      const promise = dispatch(
        createNetwork(region, projectId, networkPayload),
      );
      handleNetworkCreation(promise);
    }
  }, [
    dispatch,
    formData,
    handleNetworkCreation,
    predefined_params?.region,
    projects,
    zoneId,
  ]);

  return {
    prepareNetworkCreation,
    isCreating,
  };
};

export default useNetworkCreationHandler;
